<template>
	<div class="userInfoContainer">
		<div class="avatarNameSaveBox">
			<div class="avatarNameBox">
				<div class="avatarBox" @click="uploadPhoto">
					<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
					<img class="avatar" src="../assets/defaultAvatar.png" v-else />
					<img class="editIcon" src="../assets/Personal/iconA.png" />
				</div>
				<div class="nameBox">
					{{userInfo.user_nickname ? userInfo.user_nickname : ''}}
					<div class="editName" @click="ruleForm.user_nickname = userInfo.user_nickname;show = true">修改</div>
				</div>
			</div>
			<!-- <div class="save">
				保存
			</div> -->
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				基本信息
			</div>
			<div class="itemContent">
				<div class="phoneEmailSettingBox">
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							手机号:
							<span>{{userInfo.mobile ? hideMiddleDigits(userInfo.mobile) : ''}}</span>
						</div>
						<div class="edit" @click="phoneShow = true">修改</div>
					</div>
					<!-- <div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							邮箱:
							<span>{{userInfo.user_email ? userInfo.user_email : ''}}</span>
						</div>
						<div class="edit" @click="ruleForm.user_email = userInfo.user_email;emailShow = true">修改</div>
					</div>
					<div class="phoneEmailSettingItem" @click="likeSetShow = true">
						<div class="phoneEmailSettingItemContent">
							个人偏好设置
						</div>
						<div class="edit">修改</div>
					</div> -->
				</div>
			</div>
		</div>
		<div class="userInfoItem" style="border-bottom: none;">
			<div class="itemTitle">
				密码修改
			</div>
			<div class="itemContent">
				<el-form ref="pwdRuleForm" class="register-form" hide-required-asterisk :model="ruleForm"
					:rules="rules">
					<el-form-item label="旧密码：" prop="old_pwd">
						<div class="invite-container">
							<input :type="showOldPwd ? 'text' : 'password'" v-model="ruleForm.old_pwd"
								placeholder="请输入旧密码" class="invite-input" />
							<img class="showPwd" src="../assets/Personal/iconP.png" @click="showOldPwd = !showOldPwd"
								v-if="!showOldPwd" />
							<img class="showPwd" src="../assets/Personal/iconO.png" @click="showOldPwd = !showOldPwd"
								v-else />
							<span class="error-message" v-if="pwdErrorShow">密码错误</span>
						</div>
					</el-form-item>
					<el-form-item label="新密码：" prop="new_pwd">
						<div class="invite-container">
							<input :type="showNewPwd ? 'text' : 'password'" v-model="ruleForm.new_pwd"
								placeholder="请输入新密码" class="invite-input" />
							<img class="showPwd" src="../assets/Personal/iconP.png" @click="showNewPwd = !showNewPwd"
								v-if="!showNewPwd" />
							<img class="showPwd" src="../assets/Personal/iconO.png" @click="showNewPwd = !showNewPwd"
								v-else />
						</div>
					</el-form-item>
					<button type="button" class="save-btn" @click="submitPwdForm('pwdRuleForm')">保存</button>
				</el-form>
			</div>
		</div>
		<!-- <div class="userInfoItem" style="border: none;padding-bottom: 0;">
			<div class="itemTitle">
				收货信息
				<div class="addAddress" @click="curAddress = {};dialogAddressViable = true">新增地址</div>
			</div>
			<div class="itemContent">
				<button class="prev-btn" @click="prevImage" v-if="address.length > 3">
					<img src="../assets/MyOrder/iconH.png">
				</button>
				<div class="addressList" ref="thumbnailContainer">
					<div class="addressItem" :class="selAddressIndex == index ? 'active' : 'normal'"
						v-for="(item,index) in address" :key="index" @click="selAddressIndex = index">
						<div class="province ellipsis-1">{{item.sheng}} {{item.shi}} {{item.qu}}</div>
						<div class="address ellipsis-1">{{item.address}}</div>
						<div class="namePhone ellipsis-1">{{item.name}} {{item.phone}}</div>
						<div class="editMenu">
							<img class="editIcon" src="../assets/Personal/iconC.png"
								@click.stop="curAddress = item;dialogAddressViable = true" />
							<img class="editIcon" src="../assets/Personal/iconB.png" @click.stop="delAddress(item)" />
						</div>
					</div>
				</div>
				<button class="next-btn" @click="nextImage" v-if="address.length > 3">
					<img src="../assets/MyOrder/iconI.png">
				</button>
			</div>
		</div> -->
		<el-upload ref="upload" name="image" style="font-size: 0;"
			action="https://ht.daiyuart.com/api.php/set/Other/upload_img" :show-file-list="false"
			:on-success="handlePhotoSuccess">
		</el-upload>
		<el-dialog class="reportDialog" :visible="show" append-to-body @close="show = false">
			<div slot="title">
				<div class="dislogTitle">
					昵称修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="user_nickname">
						<el-input v-model="ruleForm.user_nickname" placeholder="请输入昵称" />
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="reportDialog" :visible="emailShow" append-to-body @close="emailShow = false">
			<div slot="title">
				<div class="dislogTitle">
					邮箱修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="user_email">
						<el-input v-model="ruleForm.user_email" placeholder="请输入邮箱" />
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitEmailForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="likeSetDialog" :visible="likeSetShow" append-to-body @close="likeSetShow = false">
			<div slot="title">
				<div class="dislogTitle">
					请选择您喜欢的标签，平台推荐更精准哦!
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="likeRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="cate">
						<div class="cateBoxTitle">
							图片分类
						</div>
						<div class="cateList">
							<div class="cateItem"
								:class="{'active': ruleForm.cate.findIndex(row => row == item.id) > -1}"
								v-for="(item,index) in typeOpts" :key="index" @click="addCate(item)">
								{{item.title}}
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="purpose">
						<div class="cateBoxTitle">
							图片用途
						</div>
						<div class="cateList">
							<div class="cateItem"
								:class="{'active': ruleForm.purpose.findIndex(row => row == item.id)>-1}"
								v-for="(item,index) in yongtuOpts" :key="index" @click="addPurpose(item)">
								{{item.title}}
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitLikeForm('likeRuleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="phoneDialog" :visible="phoneShow" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					手机号修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="phoneRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="phone">
						<div class="form-group" style="width: 3.85rem;">
							<div class="verification-container">
								<input type="email" v-model="ruleForm.phone" placeholder="请输入原手机号码"
									class="phone-input" />
								<span v-if="showPhoneError" class="error-message">原手机号错误</span>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="new_phone">
						<div class="form-group" style="width: 3.85rem;">
							<div class="phone-input-container">
								<input type="tel" v-model="ruleForm.new_phone" placeholder="请输入新手机号码"
									class="phone-input" />
								<span class="error-message" v-if="showNewPhoneError">手机号已存在</span>
								<button type="button" @click="getVerificationCode" :disabled="countdown > 0"
									class="get-code-btn">{{countdown > 0 ? countdown + 's后重新获取': '获取验证码'}}</button>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="code">
						<div class="form-group" style="width: 3.85rem;">
							<div class="verification-container">
								<input type="text" v-model="ruleForm.code" placeholder="请输入验证码"
									class="verification-input" />
								<span v-if="showVerificationError" class="error-message">验证码错误</span>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitPhoneForm('phoneRuleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<AddAddress :show="dialogAddressViable" :data="curAddress" @close="dialogAddressViable = false;curAddress = {}"
			@update="userAddress" />
	</div>
</template>

<script>
	import AddAddress from '../../src/components/AddAddress.vue'
	export default {
		components: {
			AddAddress
		},
		data() {
			return {
				ruleForm: {
					user_nickname: '',
					new_pwd: '',
					old_pwd: '',
					user_email: '',
					cate: [],
					purpose: [],
				},
				rules: {
					user_nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					user_email: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					cate: [{
						required: true,
						message: '请至少选择一个分类',
						trigger: 'blur'
					}],
					purpose: [{
						required: true,
						message: '请至少选择一个用途',
						trigger: 'blur'
					}],
					new_pwd: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					old_pwd: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入原手机号码',
						trigger: 'blur'
					}],
					new_phone: [{
						required: true,
						message: '请输入新手机号码',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
				},
				showOldPwd: false,
				showNewPwd: false,
				countdown: 0,
				typeOpts: [],
				yongtuOpts: [],
				address: [],
				show: false,
				emailShow: false,
				phoneShow: false,
				pwdErrorShow: false,
				dialogAddressViable: false,
				showVerificationError: false,
				showNewPhoneError: false,
				showPhoneError: false,
				curAddress: {},
				userInfo: {},
				password: '',
				selAddressIndex: 0,
				likeSetShow: false,
				timer: null,
			}
		},
		mounted() {
			this.userAddress()
			this.userDetails()
			this.basicsLabelList()
			this.basicsClassifyList()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			prevImage() {
				const prevIndex = (this.selAddressIndex - 1 + this.address.length) % this.address.length;
				this.selAddressIndex = prevIndex;
				this.scrollToImage();
			},
			nextImage() {
				const nextIndex = (this.selAddressIndex + 1) % this.address.length;
				this.selAddressIndex = nextIndex;
				this.scrollToImage();
			},
			scrollToImage() {
				const container = this.$refs.thumbnailContainer;
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailWidth = 2.88 * rootFontSize; // 每个缩略图的宽度，包括间隔
				const maxVisibleThumbnails = 3; // 显示的最大缩略图数量
				// 计算当前选中缩略图的偏移量
				const thumbnailOffset = this.selAddressIndex * thumbnailWidth;
				// 计算需要滚动的距离，保持最多显示3个缩略图
				if (thumbnailOffset >= container.scrollLeft + maxVisibleThumbnails * thumbnailWidth) {
					// 向右滚动
					container.scrollLeft = thumbnailOffset - maxVisibleThumbnails * thumbnailWidth + thumbnailWidth;
				} else if (thumbnailOffset < container.scrollLeft) {
					// 向左滚动
					container.scrollLeft = thumbnailOffset;
				}
			},
			userAddress() {
				this.$api.post('/UserD/user_address', {}).then(res => {
					if (res.code == 1) {
						this.address = res.data
						this.selAddressIndex = 0
						this.scrollToImage()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			delAddress(item) {
				this.$confirm('确认删除当前地址吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/UserD/user_address_del', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.userAddress()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(err => {
					console.log(err);
				});
			},
			addCate(item) {
				const index = this.ruleForm.cate.findIndex((row => row == item.id))
				if (index > -1) {
					this.ruleForm.cate.splice(index, 1)
				} else {
					this.ruleForm.cate.push(item.id)
				}
			},
			addPurpose(item) {
				const index = this.ruleForm.purpose.findIndex((row => row == item.id))
				if (index > -1) {
					this.ruleForm.purpose.splice(index, 1)
				} else {
					this.ruleForm.purpose.push(item.id)
				}
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
						this.ruleForm.cate = res.data.image_fl ? res.data.image_fl.split(',') : []
						this.ruleForm.purpose = res.data.image_yt ? res.data.image_yt.split(',') : []
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userSave(key, value) {
				let params = {}
				params[key] = value
				this.$api.post('/UserD/user_save', params).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.userDetails()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response, file) {
				console.log(file)
				this.userSave('avatar', response.data)
			},
			hideMiddleDigits(phoneNumber) {
				if (typeof phoneNumber === 'string' && phoneNumber.length === 11) {
					// 将中间四位替换为星号
					return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7);
				}
			},
			// 获取验证码
			getVerificationCode() {
				this.$refs.phoneRuleForm.validateField('new_phone', (valid) => {
					if (!valid) {
						this.$api.post('/Other/phone_code', {
							phone: this.ruleForm.new_phone,
						}).then(res => {
							if (res.code == 1) {
								this.countdown = 60;
								// 倒计时
								this.timer = setInterval(() => {
									this.countdown--;
									if (this.countdown <= 0) {
										clearInterval(this.timer);
									}
								}, 1000);
							} else {
								console.log(res.msg)
							}
							console.log(res)
						}).catch(err => {
							console.log(err);
						})
					} else {
						return
					}
				});
			},
			submitPhoneForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.showPhoneError = false
						this.showNewPhoneError = false
						this.showVerificationError = false
						if (this.ruleForm.phone != this.userInfo.mobile) {
							this.showPhoneError = true
							return
						}
						this.$api.post('/UserD/user_phone', {
							phone: this.ruleForm.phone,
							new_phone: this.ruleForm.new_phone,
							code: this.ruleForm.code,
						}).then(res => {
							if (res.code == 1) {
								this.userDetails()
								this.handleClose()
								this.$message.success(res.msg)
							} else {
								if (res.msg == '手机号已存在') {
									this.showNewPhoneError = true
								} else if (res.msg == '验证码错误') {
									this.showVerificationError = true
								}
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			handleClose() {
				if (this.timer) {
					clearInterval(this.timer);
				}
				this.phoneShow = false
				this.ruleForm.phone = ''
				this.ruleForm.new_phone = ''
				this.ruleForm.code = ''
				this.showPhoneError = false
				this.showNewPhoneError = false
				this.showVerificationError = false
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.userSave('user_nickname', this.ruleForm.user_nickname)
						this.show = false
					} else {
						return false
					}
				})
			},
			submitPwdForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/UserD/user_pwd', {
							new_pwd: this.ruleForm.new_pwd,
							old_pwd: this.ruleForm.old_pwd
						}).then(res => {
							if (res.code == 1) {
								this.showNewPwd = false
								this.showOldPwd = false
								this.ruleForm.new_pwd = ''
								this.ruleForm.old_pwd = ''
								this.pwdErrorShow = false
								this.$message.success(res.msg)
							} else {
								this.pwdErrorShow = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			submitEmailForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.userSave('user_email', this.ruleForm.user_email)
						this.emailShow = false
					} else {
						return false
					}
				})
			},
			submitLikeForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/UserD/user_save', {
							image_fl: this.ruleForm.cate.join(','),
							image_yt: this.ruleForm.purpose.join(',')
						}).then(res => {
							if (res.code == 1) {
								this.likeSetShow = false
								this.$message.success(res.msg)
								this.userDetails()
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.userInfoContainer {
		display: flex;
		flex-direction: column;
		padding: .36rem .4rem .48rem;
	}

	@media (max-width: 480px) {
		.avatarNameSaveBox {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: .64rem;
			border-bottom: .01rem solid rgba(255, 255, 255, .2);

			.avatarNameBox {
				display: flex;
				align-items: center;

				.avatarBox {
					display: flex;
					align-items: center;
					width: 1.4rem;
					height: 1.4rem;
					border-radius: 50%;
					overflow: hidden;
					position: relative;
					cursor: pointer;

					.avatar {
						width: 1.4rem;
						height: 1.4rem;
						object-fit: cover;
					}

					.editIcon {
						position: absolute;
						bottom: 0;
						left: .08rem;
						width: 1.2rem;
						height: .4rem;
					}
				}

				.nameBox {
					margin-left: .32rem;
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: .36rem;
					color: rgba(255, 255, 255, .8);

					.editName {
						margin-left: .16rem;
						width: .68rem;
						height: .4rem;
						background: rgba(152, 232, 62, .1);
						border-radius: .02rem;
						font-weight: 400;
						font-size: .24rem;
						color: rgba(152, 232, 62, 1);
						line-height: .4rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}

			.save {
				width: 1.8rem;
				height: .72rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 500;
				font-size: .24rem;
				color: #252525;
				line-height: .72rem;
				text-align: center;
			}
		}

		.userInfoItem {
			display: flex;
			flex-direction: column;
			padding-bottom: .48rem;
			border-bottom: .01rem solid rgba(255, 255, 255, .2);

			.itemTitle {
				margin-top: .24rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 600;
				font-size: .32rem;
				color: rgba(255, 255, 255, .8);

				.addAddress {
					font-weight: 400;
					font-size: .24rem;
					color: #333333;
					cursor: pointer;
				}
			}

			.itemContent {
				display: flex;
				flex-direction: column;
				position: relative;

				.prev-btn,
				.next-btn {
					position: absolute;
					width: .24rem;
					height: .56rem;
					padding: 0 0;

					img {
						width: .24rem;
						height: .56rem;
					}
				}

				.prev-btn {
					top: calc(50% - .07rem);
					left: 0;
				}

				.next-btn {
					top: calc(50% - .07rem);
					right: 0;
				}

				.phoneEmailSettingBox {
					margin-top: .48rem;
					display: flex;
					align-items: center;

					.phoneEmailSettingItem {
						margin-right: .8rem;
						display: flex;
						align-items: center;

						.phoneEmailSettingItemContent {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .28rem;
							color: rgba(185, 185, 187, 1);

							span {
								margin-left: .16rem;
								font-weight: 500;
								font-size: .36rem;
								color: rgba(255, 255, 255, 1);
							}
						}

						.edit {
							margin-left: .16rem;
							width: .68rem;
							height: .4rem;
							background: rgba(152, 232, 62, .1);
							border-radius: .02rem;
							font-weight: 400;
							font-size: .24rem;
							color: rgba(152, 232, 62, 1);
							line-height: .4rem;
							text-align: center;
							cursor: pointer;
						}
					}
				}

				.register-form {
					margin-top: .32rem;

					::v-deep .el-form-item {
						margin-bottom: .48rem;

						&__label {
							font-size: 0.28rem;
							color: rgba(255, 255, 255, .8);
							line-height: 1.04rem;
							padding: 0 .12rem 0 0;
						}
					}

					.form-group {
						margin-top: .32rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .28rem;
						color: #252525;
					}

					.invite-container {
						width: 6rem;
						height: 1.04rem;
						border: none;
						border-radius: 0.04rem;
						background: rgba(255, 255, 255, .08);
						padding: 0 0.32rem;
						font-size: 0.28rem;
						color: #333333;
						line-height: 1.04rem;
						outline: none;
						display: flex;
						align-items: center;
						justify-content: space-between;
						position: relative;

						.showPwd {
							position: absolute;
							top: calc(50% - .24rem);
							right: .2rem;
							width: .48rem;
							height: .48rem;
							cursor: pointer;
						}
					}

					.invite-input {
						width: 3.6rem;
						height: 0.8rem;
						background: none;
						border: none;
						outline: none;
						padding: 0 0;
						font-size: 0.28rem;
						color: rgba(255, 255, 255, 1);

						&::placeholder {
							color: #999999;
						}
					}

					.save-btn {
						margin-top: .16rem;
						margin-left: 2.4rem;
						width: 2.44rem;
						height: .72rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .36rem;
						font-weight: 500;
						font-size: .24rem;
						color: rgba(255, 255, 255, 1);
						line-height: .72rem;
						text-align: center;
						padding: 0 0;

					}

					// 错误提示样式
					.error-message {
						margin-right: .2rem;
						background: #F56C6C;
						padding: 0.04rem 0.09rem;
						border-radius: 0.02rem;
						font-weight: 400;
						font-size: 0.12rem;
						color: #FFFFFF;
						line-height: .18rem;
					}
				}

				.addressList {
					margin-top: .24rem;
					border-left: .14rem solid #FFFFFF;
					border-right: .14rem solid #FFFFFF;
					width: 100%;
					display: flex;
					white-space: nowrap;
					overflow-x: auto;

					.active {
						border: .01rem solid #E29358;
					}

					.normal {
						border: .01rem solid #CCCCCC;
					}

					.addressItem {
						flex-shrink: 0;
						margin-right: .16rem;
						width: 2.72rem;
						height: .95rem;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						padding: .16rem .16rem;
						border-radius: .08rem;
						cursor: pointer;
						position: relative;

						.editMenu {
							position: absolute;
							bottom: .2rem;
							right: .12rem;
							display: flex;
							align-items: center;

							.editIcon {
								margin-left: .08rem;
								width: .12rem;
								height: .12rem;
							}
						}

						.province {
							font-weight: 400;
							font-size: .12rem;
							color: #1C1C1C;
						}

						.address {
							font-weight: 500;
							font-size: .14rem;
							color: #1C1C1C;
						}

						.namePhone {
							font-weight: 400;
							font-size: .12rem;
							color: #1C1C1C;
						}
					}
				}

				.addressList::-webkit-scrollbar {
					width: 0;
					height: 0;
				}

				/* Firefox */
				.addressList {
					scrollbar-width: none;
					/* Firefox 隐藏滚动条 */
				}

				/* IE / Edge 老版本 */
				.addressList {
					-ms-overflow-style: none;
					/* IE11, Edge */
				}
			}
		}

	}

	@media (min-width: 481px) {
		.avatarNameSaveBox {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: .32rem;
			border-bottom: .01rem solid rgba(255, 255, 255, .2);

			.avatarNameBox {
				display: flex;
				align-items: center;

				.avatarBox {
					display: flex;
					align-items: center;
					width: .7rem;
					height: .7rem;
					border-radius: 50%;
					overflow: hidden;
					position: relative;
					cursor: pointer;

					.avatar {
						width: .7rem;
						height: .7rem;
						object-fit: cover;
					}

					.editIcon {
						position: absolute;
						bottom: 0;
						left: .04rem;
						width: .6rem;
						height: .2rem;
					}
				}

				.nameBox {
					margin-left: .16rem;
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: .18rem;
					color: rgba(255, 255, 255, .8);

					.editName {
						margin-left: .08rem;
						width: .34rem;
						height: .2rem;
						background: rgba(152, 232, 62, .1);
						border-radius: .02rem;
						font-weight: 400;
						font-size: .12rem;
						color: rgba(152, 232, 62, 1);
						line-height: .2rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}

			.save {
				width: .9rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 500;
				font-size: .12rem;
				color: #252525;
				line-height: .36rem;
				text-align: center;
			}
		}

		.userInfoItem {
			display: flex;
			flex-direction: column;
			padding-bottom: .24rem;
			border-bottom: .01rem solid rgba(255, 255, 255, .2);

			.itemTitle {
				margin-top: .24rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 600;
				font-size: .16rem;
				color: rgba(255, 255, 255, .8);

				.addAddress {
					font-weight: 400;
					font-size: .12rem;
					color: #333333;
					cursor: pointer;
				}
			}

			.itemContent {
				display: flex;
				flex-direction: column;
				position: relative;

				.prev-btn,
				.next-btn {
					position: absolute;
					width: .12rem;
					height: .28rem;
					padding: 0 0;

					img {
						width: .12rem;
						height: .28rem;
					}
				}

				.prev-btn {
					top: calc(50% - .07rem);
					left: 0;
				}

				.next-btn {
					top: calc(50% - .07rem);
					right: 0;
				}

				.phoneEmailSettingBox {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.phoneEmailSettingItem {
						margin-right: .4rem;
						display: flex;
						align-items: center;

						.phoneEmailSettingItemContent {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: rgba(185, 185, 187, 1);

							span {
								margin-left: .08rem;
								font-weight: 500;
								font-size: .18rem;
								color: rgba(255, 255, 255, 1);
							}
						}

						.edit {
							margin-left: .08rem;
							width: .34rem;
							height: .2rem;
							background: rgba(152, 232, 62, .1);
							border-radius: .02rem;
							font-weight: 400;
							font-size: .12rem;
							color: rgba(152, 232, 62, 1);
							line-height: .2rem;
							text-align: center;
							cursor: pointer;
						}
					}
				}

				.register-form {
					margin-top: .16rem;

					::v-deep .el-form-item {
						margin-bottom: .24rem;

						&__label {
							font-size: 0.14rem;
							color: rgba(255, 255, 255, .8);
							line-height: .52rem;
							padding: 0 .12rem 0 0;
						}
					}

					.form-group {
						margin-top: .16rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
					}

					.invite-container {
						width: 3rem;
						height: 0.52rem;
						border: none;
						border-radius: 0.04rem;
						background: rgba(255, 255, 255, .08);
						padding: 0 0.16rem;
						font-size: 0.14rem;
						color: #333333;
						line-height: .52rem;
						outline: none;
						display: flex;
						align-items: center;
						justify-content: space-between;
						position: relative;

						.showPwd {
							position: absolute;
							top: calc(50% - .12rem);
							right: .1rem;
							width: .24rem;
							height: .24rem;
							cursor: pointer;
						}
					}

					.invite-input {
						width: 1.8rem;
						height: 0.4rem;
						background: none;
						border: none;
						outline: none;
						padding: 0 0;
						font-size: 0.14rem;
						color: rgba(255, 255, 255, 1);

						&::placeholder {
							color: #999999;
						}
					}

					.save-btn {
						margin-top: .08rem;
						margin-left: 1.2rem;
						width: 1.22rem;
						height: .36rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .18rem;
						font-weight: 500;
						font-size: .12rem;
						color: rgba(255, 255, 255, 1);
						line-height: .36rem;
						text-align: center;
						padding: 0 0;

					}

					// 错误提示样式
					.error-message {
						margin-right: .2rem;
						background: #F56C6C;
						padding: 0.04rem 0.09rem;
						border-radius: 0.02rem;
						font-weight: 400;
						font-size: 0.12rem;
						color: #FFFFFF;
						line-height: .18rem;
					}
				}

				.addressList {
					margin-top: .24rem;
					border-left: .14rem solid #FFFFFF;
					border-right: .14rem solid #FFFFFF;
					width: 100%;
					display: flex;
					white-space: nowrap;
					overflow-x: auto;

					.active {
						border: .01rem solid #E29358;
					}

					.normal {
						border: .01rem solid #CCCCCC;
					}

					.addressItem {
						flex-shrink: 0;
						margin-right: .16rem;
						width: 2.72rem;
						height: .95rem;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						padding: .16rem .16rem;
						border-radius: .08rem;
						cursor: pointer;
						position: relative;

						.editMenu {
							position: absolute;
							bottom: .2rem;
							right: .12rem;
							display: flex;
							align-items: center;

							.editIcon {
								margin-left: .08rem;
								width: .12rem;
								height: .12rem;
							}
						}

						.province {
							font-weight: 400;
							font-size: .12rem;
							color: #1C1C1C;
						}

						.address {
							font-weight: 500;
							font-size: .14rem;
							color: #1C1C1C;
						}

						.namePhone {
							font-weight: 400;
							font-size: .12rem;
							color: #1C1C1C;
						}
					}
				}

				.addressList::-webkit-scrollbar {
					width: 0;
					height: 0;
				}

				/* Firefox */
				.addressList {
					scrollbar-width: none;
					/* Firefox 隐藏滚动条 */
				}

				/* IE / Edge 老版本 */
				.addressList {
					-ms-overflow-style: none;
					/* IE11, Edge */
				}
			}
		}
	}


	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;
			background: #1F2027;
			box-shadow: 0px 2px 23px 0px rgba(16, 97, 198, 0.2);
			border: .01rem solid rgba(151, 151, 151, 0.2);

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: rgba(255, 255, 255, .4);
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: none;
									background: rgba(255, 255, 255, .08);
									color: rgba(255, 255, 255, 1);
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .08rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .18rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: rgba(255, 255, 255, 1);
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.likeSetDialog {
		::v-deep .el-dialog {
			width: 10.48rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.cateBoxTitle {
		font-weight: 400;
		font-size: .16rem;
		color: #333333;
		line-height: .22rem;
	}

	.cateList {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.cateItem {
			margin-top: .24rem;
			margin-right: .32rem;
			width: 1.28rem;
			height: .48rem;
			font-weight: 400;
			font-size: .16rem;
			color: #666666;
			border-radius: .04rem;
			border: .01rem solid #CCCCCC;
			line-height: .48rem;
			text-align: center;
			cursor: pointer;

			// &:hover {
			// 	color: #E29358;
			// 	border-color: #E29358;
			// }

			&.active {
				color: #E29358;
				border-color: #E29358;
			}
		}
	}


	.phoneDialog {
		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;
			background: #1F2027;
			box-shadow: 0px 2px 23px 0px rgba(16, 97, 198, 0.2);
			border: .01rem solid rgba(151, 151, 151, 0.2);

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: rgba(255, 255, 255, .4);
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				padding: 0 .24rem;

				.form-group {
					// margin-top: .16rem;
				}

				.form-input {
					width: 100%;
					height: 0.44rem;
					border: none;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					background: rgba(255, 255, 255, .08);
					transition: border-color 0.3s ease;

					// &:focus {
					// 	border-color: #E29358;
					// }

					&::placeholder {
						color: #999999;
					}
				}

				// 手机号和验证码输入框样式
				.phone-input-container,
				.verification-container,
				.invite-container {
					width: 100%;
					height: 0.44rem;
					border: none;
					border-radius: 0.04rem;
					background: rgba(255, 255, 255, .08);
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.phone-input,
				.verification-input,
				.invite-input {
					height: 0.4rem;
					width: 1.8rem;
					border: none;
					outline: none;
					background: none;
					padding: 0 0;
					font-size: 0.14rem;
					color: rgba(255, 255, 255, 1);

					&::placeholder {
						color: rgba(255, 255, 255, .4);
					}
				}

				.get-code-btn {
					padding: 0 0;
					color: rgba(152, 232, 62, 1);
					font-size: 0.14rem;
					cursor: pointer;

					&:disabled {
						background: none;
						color: #CCCCCC;
						border: none;
						cursor: not-allowed;
					}
				}

				// 错误提示样式
				.error-message {
					background: #F56C6C;
					padding: 0.04rem 0.09rem;
					border-radius: 0.02rem;
					font-weight: 400;
					font-size: 0.12rem;
					color: #FFFFFF;
					line-height: .22rem;
				}


				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .08rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: rgba(22, 115, 230, 1);
						border-radius: .18rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: rgba(255, 255, 255, 1);
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>